<template>
  <div v-if="currentOf">
    <div class="mt-4 mb-4">
      <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
        <alert-error
          v-if="form.errors.get('message')"
          :form="form"
          :message="form.errors.get('message')"
        ></alert-error>
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <div class="row d-flex justify-content-lg-center">
                  <div class="col-md-4 col-lg-2">
                    <div class="form-group">
                      <label for="date"
                        >Date consommation
                        <span class="text-danger">*</span></label
                      >
                      <date-picker
                        v-model="form.date"
                        name="date"
                        placeholder="Date consommation"
                        lang="fr"
                        format="DD/MM/YYYY"
                        value-type="DD/MM/YYYY"
                      ></date-picker>
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('date'),
                        }"
                        type="hidden"
                      />
                      <has-error :form="form" field="date"></has-error>
                    </div>
                  </div>

                  <div class="col-md-8 col-lg-3 mt-n4 mt-md-0">
                    <div class="form-group">
                      <label for="etape"
                        >Etape <span class="text-danger">*</span></label
                      >
                      <v-custom-select
                        label="libelle"
                        :options="etapes"
                        :reduce="(etape) => etape.uuid"
                        v-model="form.etape"
                        placeholder="Etape"
                        @input="onChangeEtape"
                      >
                        <template v-slot:option="{ libelle, poste_charge }">
                          <h5 style="margin: 0">{{ libelle }}</h5>
                          <span v-if="poste_charge" class="d-block">
                            Poste de charge : {{ poste_charge.nom }}
                          </span>
                          <span v-if="poste_charge.entrepot" class="d-block">
                            Entrepôt : {{ poste_charge.entrepot.nom }}
                          </span>
                        </template>
                        <template #no-options> Aucune donnée </template>
                        <template #search="{ attributes, events }">
                          <input
                            id="etape"
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                      <div>
                        <input
                          type="hidden"
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('etape'),
                          }"
                        />
                        <has-error :form="form" field="etape"></has-error>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-3 mt-n4 mt-md-0">
                    <div class="form-group">
                      <label for="entrepot">Entrepôt </label>
                      <input
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('entrepot') }"
                        id="entrepot"
                        :value="entrepot ? entrepot.nom : ''"
                        type="text"
                        placeholder="Entrepôt"
                        disabled
                      />
                      <has-error :form="form" field="entrepot"></has-error>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-n4">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body mt-n2 mb-n2">
                <div class="row mt-n2 d-flex justify-content-center">
                  <div class="col-md-8 col-lg-6">
                    <cool-select
                      v-model="selectedArticle"
                      :items="articles"
                      item-text="designation"
                      placeholder="Recherche article"
                      @select="onSelectedArticle"
                      :search-text.sync="searchText"
                    >
                      <template #no-data>
                        {{
                          articles.length === 0
                            ? 'Aucun resultat.'
                            : '2 caratères pour lancer la recherche.'
                        }}
                      </template>
                      <template #item="{ item }">
                        <div class="item">
                          <div>
                            <h5>{{ item.designation }}</h5>
                            <span v-if="item.reference" class="d-block">
                              Référence : {{ item.reference }}
                            </span>
                            <span v-if="item.unite" class="d-block">
                              Quantité prévue :
                              {{ item.qte_prevue + ' ' + item.unite }}
                            </span>
                            <span v-if="item.unite" class="d-block">
                              Stock : {{ item.stock + ' ' + item.unite }}
                            </span>
                          </div>
                        </div>
                      </template>
                    </cool-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <b-alert
          :show="itemListErrorMessage !== null"
          dismissible
          variant="danger"
        >
          <span v-html="itemListErrorMessage"></span>
        </b-alert>
        <div class="row mt-n4">
          <div class="col-md-12">
            <table class="card table table-sm">
              <thead>
                <tr class="d-flex">
                  <th class="col-2">Article</th>
                  <th class="col-2 text-center">Qté prévue</th>
                  <th class="col-2 text-center">Déjà consommée</th>
                  <th class="col-2 text-center">Stock</th>
                  <th class="col-2 text-center">N° Lot</th>
                  <th class="col-1 text-center">Quantité</th>
                  <th class="col-1 text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in item_lists" :key="index">
                  <td class="col-2" style="vertical-align: middle">
                    Désignation : {{ item.designation }} <br />
                    Réference : {{ item.reference }} <br />
                    Gestion par lot :
                    {{ item.gestion_lot === true ? 'Oui' : 'Non' }}
                  </td>
                  <td class="col-2 text-center" style="vertical-align: middle">
                    {{ item.qte_prevue + ' ' + item.unite }}
                  </td>
                  <td
                    class="col-2 text-center"
                    :class="{
                      'text-danger': item.qte_historique > item.qte_prevue,
                    }"
                    style="vertical-align: middle"
                  >
                    {{ item.qte_historique + ' ' + item.unite }}
                  </td>
                  <td class="col-2 text-center" style="vertical-align: middle">
                    <span
                      v-if="item.gestion_lot && !item.lot"
                      class="text-danger"
                    >
                      Choisir un lot
                    </span>
                    <span v-else>
                      {{ item.stock + ' ' + item.unite }}
                    </span>
                  </td>
                  <td class="col-2" style="vertical-align: middle">
                    <v-custom-select
                      :disabled="!item.gestion_lot"
                      label="lot"
                      :options="item.lots"
                      :reduce="(lot) => lot.uuid"
                      v-model="item.lot"
                      placeholder="N° Lot"
                      @input="onChangeLot(item)"
                    >
                      <template v-slot:option="{ lot, dlc, dluo }">
                        <h5 style="margin: 0">{{ lot }}</h5>
                        <span v-if="dlc" class="d-block">
                          DLC : {{ dlc }}
                        </span>
                        <span v-if="dluo" class="d-block">
                          DLUO : {{ dluo }}
                        </span>
                      </template>
                      <template #no-options> Aucune donnée </template>
                      <template #search="{ attributes, events }">
                        <input
                          id="lot"
                          class="custom-select-height vs__search"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                    </v-custom-select>
                  </td>

                  <td class="col-1" style="vertical-align: middle">
                    <input
                      class="form-control"
                      v-model="item.quantite"
                      type="text"
                      placeholder="Quantité"
                      @focus="$event.target.select()"
                    />
                  </td>
                  <td class="col-1 text-center" style="vertical-align: middle">
                    <a
                      class="cursor-pointer"
                      @click.prevent="removeItem(index)"
                    >
                      <i
                        :class="consommation.ICON_TRASH"
                        class="font-size-17 text-danger"
                      ></i
                    ></a>
                  </td>
                </tr>
                <tr v-if="item_lists.length === 0" class="d-flex">
                  <td colspan="6" class="text-center col-12">Aucune donnée</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="row mb-4 mt-2">
          <div class="col-md-12 text-right">
            <button
              type="button"
              class="btn btn-secondary mr-4"
              @click.prevent="
                $router
                  .push({ name: listUrl, params: { id: currentOf.id } })
                  .catch(() => {})
              "
            >
              Liste des consommations
            </button>

            <ButtonLoader
              :busy="form.busy"
              type="submit"
              customClass="btn btn-custom-primary w-40"
              loadText="Traitement en cours..."
              Text="Enregistrer"
              style="min-width: 100px"
            ></ButtonLoader>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import URL_O from '@/http/gpao/of';
import URL_C from '@/http/gpao/consommation';
import { consommation } from '@/icons/gpao/of';
import URL_E from '@/http/gpao/of-etape';
import DatePicker from 'vue2-datepicker';
import Form from 'vform';
import { mapGetters } from 'vuex';
import { CoolSelect } from 'vue-cool-select';

export default {
  data() {
    return {
      consommation,

      form: new Form({
        date: this.$options.filters.formatDate(new Date(), 'DD/MM/YYYY'),
        entrepot: '',
        etape: '',
      }),
      item_lists: [],

      etapes: [],
      articles: [],

      selectedArticle: null,
      searchText: null,

      itemListErrorMessage: null,
    };
  },
  components: {
    DatePicker,
    CoolSelect,
  },
  computed: {
    ...mapGetters('of', ['currentOf']),
    entrepot() {
      if (!this.form.etape) return null;

      return window._.find(this.etapes, (e) => e.uuid === this.form.etape)
        .poste_charge.entrepot;
    },
    listUrl() {
      return this.$route.name.split('-')[0];
    },
  },
  methods: {
    onSelectedArticle: function (select) {
      if (select) {
        let item = {
          matiere_etape: select.matiere_etape,
          designation: select.designation,
          reference: select.reference,
          unite: select.unite,
          lot: null,
          lots: select.lots,
          stocks: select.stocks,
          consommations: select.consommations,
          qte_prevue: select.qte_prevue || 0,
          quantite: select.qte_prevue,
          stock: 0,
          qte_historique: 0,
          gestion_lot: select.gestion_lot,
        };

        this.item_lists.push(item);
        this.stockDetails(item);

        this.searchText = null;
        this.selectedArticle = null;
      }
    },
    removeItem: function (index) {
      this.item_lists.splice(index, 1);
    },
    init() {
      this.etapes = [];
      this.item_lists = [];

      window.axios
        .get(URL_O.GET_ETAPES + '/' + this.$route.params.id)
        .then((resp) => {
          this.etapes = resp.data.etapes;
        })
        .catch();
    },
    getEtapeMatieres() {
      this.item_lists = [];
      let etape = window._.find(this.etapes, (e) => e.uuid === this.form.etape);

      if (etape && this.entrepot) {
        window.axios
          .get(URL_E.GET_MATIERES + '/' + etape.id, {
            params: {
              consommation_of: true,
              entrepot: this.entrepot.uuid,
            },
          })
          .then((resp) => {
            this.articles = resp.data.matieres.map((item) => {
              let data = {
                matiere_etape: item.matiere_etape,
                designation: item.designation,
                reference: item.reference,
                unite: item.unite,
                lot: null,
                lots: item.lots,
                stocks: item.stocks,
                consommations: item.consommations,
                qte_prevue: item.qte_prevue || 0,
                quantite: item.qte_prevue,
                stock: 0,
                qte_historique: 0,
                gestion_lot: item.gestion_lot,
              };

              this.stockDetails(data);
              return data;
            });
            this.item_lists = Object.assign([], this.articles);
          })
          .catch();
      }
    },
    stockDetails(item) {
      if (item.gestion_lot) {
        let stock = window._.find(
          item.lots,
          (stk) =>
            stk.entrepot_uuid === this.entrepot.uuid && stk.uuid === item.lot
        );

        let historique = window._.sumBy(
          window._.filter(
            item.consommations,
            (conso) => conso.lot === item.lot
          ),
          (conso) => conso.quantite
        );

        item.stock = stock ? stock.quantite : 0;
        item.qte_historique = historique ? historique : 0;
      } else {
        let stock = window._.find(
          item.stocks,
          (stk) => stk.entrepot_uuid === this.entrepot.uuid
        );

        let historique = window._.sumBy(
          item.consommations,
          (conso) => conso.quantite
        );

        item.stock = stock ? stock.quantite : 0;
        item.qte_historique = historique;
      }
    },

    onChangeLot(item) {
      this.stockDetails(item);
    },
    onChangeEntrepot() {
      this.getEtapeMatieres();
    },
    onChangeEtape() {
      this.getEtapeMatieres();
    },
    submit() {
      if (this.entrepot) this.form.entrepot = this.entrepot.uuid;
      this.itemListErrorMessage = null;
      this.form.item_lists = this.item_lists.map((item) => {
        let identifiant = item.matiere_etape;
        if (item.lot) identifiant += item.lot;

        return {
          identifiant: identifiant,
          matiere_etape: item.matiere_etape,
          designation: item.designation,
          reference: item.reference,
          unite: item.unite,
          lot: item.lot || null,
          quantite: item.quantite,
          gestion_lot: item.gestion_lot,
        };
      });
      this.form
        .post(URL_C.CONSOMMATION)
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);
          this.form.reset();
          this.init();
        })
        .catch((err) => {
          window._.forEach(err.response.data.errors, (value, key) => {
            if (key.includes('item_lists')) {
              this.itemListErrorMessage = value[0];
            } else {
              this.form.errors.set('message', err.response.data.message);
            }
            return 0;
          });
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
